import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    MAGAYANETWORKCONFIGURATION_FEATURE_KEY,
    //magayaNetworkConfigurationAdapter,
    MagayaNetworkConfigurationPartialState,
    State,
} from './magaya-network-configuration.reducer';

// Lookup the 'MagayaNetworkConfiguration' feature state managed by NgRx
export const getMagayaNetworkConfigurationState = createFeatureSelector<
    MagayaNetworkConfigurationPartialState,
    State
>(MAGAYANETWORKCONFIGURATION_FEATURE_KEY);

/*
const { selectAll, selectEntities } =
    magayaNetworkConfigurationAdapter.getSelectors();
*/

export const getMagayaNetworkConfiguration = createSelector(
    getMagayaNetworkConfigurationState,
    (state: State) => state.magayaNetworkConfiguration
);

export const getMagayaNetworkConfigurationLoading = createSelector(
    getMagayaNetworkConfigurationState,
    (state: State) => state.loading
);

export const getMagayaNetworkConfigurationError = createSelector(
    getMagayaNetworkConfigurationState,
    (state: State) => state.error
);

export const getMagayaNetworkConfigurationInitialized = createSelector(
    getMagayaNetworkConfigurationState,
    (state: State) => state.initialized
);
